import {createAsyncThunk} from '@reduxjs/toolkit'
import UserService from '@/services/api/User'
import {
  CLEAR_USER_DATA,
  SET_BILLBOARDS,
  SET_BOOSTERS,
  SET_DEFAULT_OCTA_COIN_ORB,
  SET_DEFAULT_OCTA_COIN_R_ORB,
  SET_INVENTORY,
  SET_MINERS,
  SET_MISC,
  SET_ORBS,
  SET_USER,
} from '@/store/slices'
import {
  CLEAR_LOCAL_STORAGE,
  SET_ACCOUNT,
  SET_TYPE_LOGIN,
} from '@/store/slices/storage'
import {TYPE_LOGIN_ENUM} from '@/types/enums'
import MapService from '@/services/api/Map'
import {ObjectOfMapInterface} from '@/types/types'
import {extractMiners} from '@/helpers/extractMiners'
import OrbsService from '@/services/api/Orbs'
import axios, {AxiosResponse} from 'axios'
import {setWallet} from '@/store/actions/wallet'
import {CLEAR_WALLET} from '@/store/slices/wallet'
import InventoriesService from '@/services/api/Inventories'
import {errorCodeHandler} from '@/helpers/localErrorCodeHandler'

export const getUser = createAsyncThunk(
  'index/getUser',
  async (_, {dispatch}) => {
    try {
      const response = await UserService.getUser()
      if (response.status === 200) {
        dispatch(SET_USER(response.data))
        dispatch(setWallet(response.data))
        return {success: true}
      }
      return true
    } catch (e) {}
  }
)

export const updateUser = createAsyncThunk(
  'index/updateUser',
  async (_, {dispatch}) => {
    try {
      const response = await UserService.getUser()
      if (response.status === 200) {
        dispatch(SET_USER(response.data))
        dispatch(setWallet(response.data))
        return {success: true}
      }
    } catch (e) {}
  }
)

export const logoutUser = createAsyncThunk(
  'storage/logoutUser',
  (_, {dispatch}) => {
    dispatch(SET_ACCOUNT(null))
    dispatch(SET_TYPE_LOGIN(TYPE_LOGIN_ENUM.none))
    dispatch(CLEAR_USER_DATA())
    dispatch(CLEAR_WALLET())
    dispatch(CLEAR_LOCAL_STORAGE())
  }
)

export const getOrbs = createAsyncThunk(
  'index/getOrbs',
  async (_, {dispatch}) => {
    try {
      const response = await MapService.getObjects('SOURCE_ORB')
      const objects: {
        1: ObjectOfMapInterface[]
        2: ObjectOfMapInterface[]
        3: ObjectOfMapInterface[]
      } = {1: [], 2: [], 3: []}
      if (response.status === 200) {
        response.data.all_objects.forEach((object) => {
          if (object.type === 'BILLBOARDS') {
            return
          }

          objects[object.level].push(object)
        })
        dispatch(SET_DEFAULT_OCTA_COIN_ORB(response.data.default_octa_coins))
        dispatch(SET_ORBS(objects))
      }
    } catch (e) {
      errorCodeHandler(e)
    }
  }
)

export const getOrbsR = createAsyncThunk(
  'index/getOrbsR',
  async (_, {dispatch}) => {
    try {
      const response = await OrbsService.getOrbsR()
      if (response.status === 200) {
        dispatch(SET_DEFAULT_OCTA_COIN_R_ORB(response.data.default_octa_coins))
        dispatch(SET_BILLBOARDS(response.data))
      }
    } catch (e) {
      errorCodeHandler(e)
    }
  }
)

export const getInventories = createAsyncThunk(
  'index/getInventories',
  async (_, {dispatch}) => {
    try {
      const response = await InventoriesService.getResource()
      if (response.status === 200) {
        dispatch(SET_BOOSTERS(response.data.boosters))
        dispatch(SET_INVENTORY(response.data.inventories))
        dispatch(SET_MINERS(extractMiners(response.data)))
        dispatch(
          SET_MISC(
            Array.isArray(response.data?.misc) ? response.data.misc : []
          )
        )
      }
    } catch (e) {
      errorCodeHandler(e)
    }
  }
)

type RequestFunction<T, U> = (data: U) => Promise<AxiosResponse<T>>

export const apiRequestWithData = async <T, U>(
  requestFunction: RequestFunction<T, U>,
  data: U
): Promise<AxiosResponse<T>> => {
  try {
    const response = await requestFunction(data)
    return response
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      return error.response as AxiosResponse<T>
    }
    throw error
  }
}

type RequestFunctionWithout<T> = () => Promise<AxiosResponse<T>>

export const apiRequestWithoutData = async <T>(
  requestFunction: RequestFunctionWithout<T>
): Promise<AxiosResponse<T>> => {
  try {
    const response = await requestFunction()
    return response
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      return error.response as AxiosResponse<T>
    }
    throw error
  }
}
